

import {
initWxJSSDK,
wxGetJsApiConfig,
getActivity,
getQrCodeSerialNumber,
createActivityOrder,
getPartner
} from "@/common/js/api.js";
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'
import Selector from 'vux/src/components/selector/index.vue'


export default {
components: {
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
VChart,
VTooltip,
VLine,
Flexbox,
FlexboxItem,
VScale,
Selector
},
methods: {
inputTypeChange(v) {
if (v == "扫码") {
this.view.inputTypeFlag = 1;
} else {
this.view.inputTypeFlag = 2;
}
},
getActivity(activityId) {
let self = this;
getActivity({ data: { activityId: activityId } }).then(function(data) {
self.activity = data.Content;
document.title = self.activity.activityName;
self.loaded = true;
if (!self.partnerId) {
self.coverImg = self.activity.extInfo.coverImg;
}
});
},
getPartner(partnerId) {
let self = this;
getPartner({ data: { partnerId: partnerId } }).then(function(data) {
self.partner = data.Content;
self.loaded = true;
if (self.partner.imagePaths) {
self.coverImg = self.partner.imagePaths;
} else {
self.coverImg = "../../static/images/partner_activity_cover.jpg";
}
});
},
scanQRCode() {
let self = this;

this.$wechat.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function(res) {



var result = res.resultStr; 
if (result.split(",").length > 1) {
result = result.split(",")[1];
}
if (result.indexOf("http") > -1) {
self.$vux.toast.text("请扫包裹条形码或手工输入条码");
return;
}

if (self.entity.activityType == 3) {
getQrCodeSerialNumber({
data: { qrData: result, activityId: self.entity.activityId }
}).then(function(data) {
self.entity.qrId = data.Content + "";
});
} else {

self.entity.qrId = result;
}
}
});
},
createOrder() {
let self = this;
createActivityOrder({ data: self.entity }).then(function(data) {
self.$router.push({ path: "/usercenter/orderList" });
});
},
onSubmit() {
let self = this;
if (!self.entity.qrId) {
self.$vux.toast.text("请扫包裹条形码或手工输入条码");
return;
}
this.$vux.confirm.show({

title: "提醒您",
content: "确定下单吗？",
onCancel() {},
onConfirm() {
self.createOrder();
}
});
}
},
data() {
return {
title: "活动详情",
activity: {
extInfo: {}
},
entity: {
activityId: "",
qrId: "",
memo: ""
},
partner: {},
loaded: false,
view: {
inputTypeFlag: 1,
inputType: "扫码",
inputTypes: ["扫码", "手工录入"]
},
partnerId: "",
coverImg: ""
};
},
mounted() {
let activityId = this.$route.query.activityId;
this.partnerId = this.$route.query.partnerId;
this.entity.activityId = activityId;
this.entity.partnerId = this.partnerId;
if (this.$route.query.qrId) {
this.entity.qrId = this.$route.query.qrId;
}
if (this.partnerId) {
this.getPartner(this.partnerId);
}
this.getActivity(activityId);
initWxJSSDK();
}
};



// WEBPACK FOOTER //
// ./src/components/activity/Appointment.vue